
import { alpha, styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import baseTheme from "../themes/baseTheme";
import ReactNumeric from "react-numeric-input";
import { TextField } from "@mui/material";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    border: `1px solid ${baseTheme.palette.grey[40]}`,
    fontSize: "0.9rem",
    padding: "0.4rem 0.6rem",
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function ({
  defaultValue,
  placeholder,
  width = "300px",
  handleChange,
  type,
  min,
  max,
  required,
  ...props
 
  
}) {
  return (
    <TextField
      type={type}
      // defaultValue={defaultValue || ""}
      placeholder={placeholder}
      sx={{ width }}
      onChange={handleChange}
      {...props}
      inputProps={{ min, max }}
     
    />
  );
}
